export enum PlaylistItemType {
    UploadFile,
    RecentFile,
    Url,
    LocalFile,
    Foreground
}
